class _utils {
  constructor() {
    this.breakpoint = 900;
    this.preWidth = 0;
  }

  fit(el, ispc, ratioW, ratioH, adjustW, adjustH) {
    const winW = this.getBodyWidth();
    const winH = window.innerHeight;
    let mvW = winW - adjustW;
    let mvH = winH - adjustH;

    let frameW = 0;
    let frameH = 0;
    let frameX = 0;
    let frameY = 0;

    if (ispc || (!ispc && this.preWidth !== winW)) {
      const scale = Math.max(winW / ratioW, mvH / ratioH);
      frameW = ratioW * scale;
      frameH = ratioH * scale;
      frameX = (winW - frameW) / 2;
      frameY = (mvH - frameH) / 2;

      // 要素を画面にフィットさせる
      el.style.width = `${mvW}px`;
      el.style.height = `${mvH}px`;

      /*
      const m = this.$refs['video-src'];
      m.style.left = `${frameX}px`;
      m.style.top = `${frameY}px`;
      m.style.width = `${frameW}px`;
      m.style.height = `${frameH}px`;
      */
    }

    this.preWidth = winW;

    return {
      fw: frameW,
      fh: frameH,
      fx: frameX,
      fy: frameY
    };
  }

  fitInner(el, elInner, ispc, ratioW, ratioH, adjustW, adjustH) {
    const winW = this.getBodyWidth();
    const winH = window.innerHeight;
    let mvW = winW - adjustW;
    let mvH = winH - adjustH;

    let frameW = 0;
    let frameH = 0;
    let frameX = 0;
    let frameY = 0;

    if (ispc || (!ispc && this.preWidth !== winW)) {
      const scale = Math.max(winW / ratioW, mvH / ratioH);
      frameW = ratioW * scale;
      frameH = ratioH * scale;
      frameX = (winW - frameW) / 2;
      frameY = (mvH - frameH) / 2;

      // 要素を画面にフィットさせる
      el.style.width = `${mvW}px`;
      el.style.height = `${mvH}px`;

      // 要素の中（video or img）をフィットさせる
      elInner.style.left = `${frameX}px`;
      elInner.style.top = `${frameY}px`;
      elInner.style.width = `${frameW}px`;
      elInner.style.height = `${frameH}px`;
    }

    this.preWidth = winW;
  }

  getBodyWidth() {
    return document.body.clientWidth || window.innerWidth;
  }

  getMatchMedia() {
    return window.matchMedia('(max-width: ' + this.breakpoint +'px)').matches;
  }

  getMatchMedia1800() {
    return window.matchMedia('(min-width: 1800px)').matches;
  }

  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }
}

const utils = new _utils();

export default utils;